module.exports = __webpack_public_path__ + "img/ic_info.24f7f066.svg";